import { orchestrator } from 'satcheljs';
import { onAvailableWidthBucketChanged } from '../actions/onAvailableWidthBucketChanged';
import { drawerPaneWidthChanged } from 'owa-drawer';
import { getDrawerPaneAnchorRegistration } from 'owa-drawer/lib/selectors/getDrawerPaneAnchor';
import LayoutChangeSource from '../store/schema/LayoutChangeSource';
import calculateAvailableWidthBucket from '../utils/calculateAvailableWidthBucket';
import { isUnderRibbonAddinsPane } from '../utils/isUnderRibbonAddinsPane';
import { updateFlexPaneInternalWidth } from '../utils/updateFlexPaneInternalWidth';
import { getAreDisplayAdsEnabled } from '../selectors/getAreDisplayAdsEnabled';
import { setBrowserWidthBucket } from '../actions/setAvailableHeightAndWidthBuckets';

orchestrator(drawerPaneWidthChanged, actionMessage => {
    const { paneId, targetWindow: eventWindow } = actionMessage;
    const targetWindow = eventWindow ?? window;

    // Layout bucket system is main-window only.
    // Pop-out windows have their own simpler layout and don't participate in bucket calculations.
    const isMainWindow = targetWindow === window;

    // Skip the main-window width-bucket recalc for the calendar-form under-ribbon add-in drawer:
    // its underlay lives inside the form, not as a main-row flex sibling, so recomputing would
    // reflow the page behind the dialog. Mail keeps its recalc (its drawer is a real flex sibling).
    const isCalendarFormAddinDrawer =
        isUnderRibbonAddinsPane(paneId) &&
        getDrawerPaneAnchorRegistration(targetWindow, paneId)?.surface === 'calendar';

    if (isMainWindow && !isCalendarFormAddinDrawer) {
        const newAvailableWidthBucket = calculateAvailableWidthBucket(
            false /* skipCache */,
            getAreDisplayAdsEnabled(),
            true /* isShown — width only changes for visible panes */,
            paneId
        );
        setBrowserWidthBucket(newAvailableWidthBucket);
        onAvailableWidthBucketChanged(
            newAvailableWidthBucket,
            LayoutChangeSource.OwaSuiteHeaderFlexPaneExpandOrCollapse
        );
    }

    // CSS variable update is per-window — always run it
    updateFlexPaneInternalWidth(paneId, targetWindow);
});
